export enum AuthorizedActions {
    ALLOW_FILE_UPLOAD
}

export const AuthorizedActionsRoutes: { [key: string]: string } = {
    [AuthorizedActions[AuthorizedActions.ALLOW_FILE_UPLOAD]]: '/fileUpload'
}